// extracted by mini-css-extract-plugin
export default {"container":"container-UGkRktwc","label":"label-hJaSIsc5","value":"value-r5ugqO_e"};